import React, { lazy, useState, Suspense, useEffect } from 'react'
import './Api.css'
import { Layout } from 'components'
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Container
} from 'reactstrap'
import { useLocation, useNavigate } from 'react-router-dom'

const ApiList = lazy(() => import('./ApiList'))
const ApiCasinoList = lazy(() => import('./ApiCasinoList'))
const ApiSlotList = lazy(() => import('./ApiSlotList'))

function Api (props) {
  const { search, pathname } = useLocation()
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState('all')

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
      navigate(`${pathname}?tab=${tab}`)
    }
  }

  useEffect(() => {
    const tabParam = new URLSearchParams(search).get('tab')
    const initialTab = tabParam || 'all'
    setActiveTab(initialTab)
  }, [])

  return (
    <Layout>
      <Container className='page-content' fluid style={{ padding: 30 }}>
        <Row>
          <Nav tabs>
            {[
              { tab: 'all', label: '전체' },
              // { tab: 'sports', label: '스포츠' },
              // { tab: 'casino', label: '카지노' },
              // { tab: 'slot', label: '슬롯' },
            ].map(({ tab, label }) => (
              <NavItem key={tab}>
                <NavLink
                  className={activeTab === tab ? 'sub-link active' : ''}
                  onClick={() => toggleTab(tab)}
                >
                  {label}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </Row>
        <Row>
          <TabContent activeTab={activeTab}>
            {[
              { tab: 'all', component: <ApiList /> },
              { tab: 'sports', component: <ApiList type={'sports'} /> },
              { tab: 'casino', component: <ApiList type={'casino'} /> },
              { tab: 'slot', component: <ApiList type={'slot'} /> },
            ].map(({ tab, component }) => (
              <TabPane key={tab} tabId={tab}>
                {activeTab === tab && ( // Only render the component when the activeTab matches the current tab
                  <Suspense fallback={<div>Loading...</div>}>
                    {component}
                  </Suspense>
                )}
              </TabPane>
            ))}
          </TabContent>
        </Row>
      </Container>
    </Layout>
  )
}

export default Api
